"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PhoneCharger: ['phone-charger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.75,13a1,1,0,0,0-1-1H21a6.257,6.257,0,0,0-6.25,6.25V19a3,3,0,0,1-6,0V17.233a.251.251,0,0,1,.214-.248A1.5,1.5,0,0,0,10.25,15.5V13.76a.25.25,0,0,1,.161-.234A5.78,5.78,0,0,0,14.25,8V5a1.5,1.5,0,0,0-1.5-1.5H12a.25.25,0,0,1-.25-.25V1a1,1,0,1,0-2,0v2.25a.25.25,0,0,1-.25.25H6a.25.25,0,0,1-.25-.25V1a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H2.75A1.5,1.5,0,0,0,1.25,5V8a5.78,5.78,0,0,0,3.839,5.525.25.25,0,0,1,.161.234V15.5a1.5,1.5,0,0,0,1.286,1.484.25.25,0,0,1,.214.248V19a5,5,0,0,0,10,0v-.75A4.255,4.255,0,0,1,21,14h.75A1,1,0,0,0,22.75,13ZM10.5,7a.75.75,0,0,1-.75.75h-4a.75.75,0,0,1,0-1.5h4A.75.75,0,0,1,10.5,7Z']],
  Charger1: ['charger-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,6H17.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v4.25a.25.25,0,0,1-.25.25H9.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v4.25A.25.25,0,0,1,6.25,6H4A1.5,1.5,0,0,0,4,9H20a1.5,1.5,0,1,0,0-3Z', 'M18,10.5H6a.5.5,0,0,0-.5.5v2.5a4.488,4.488,0,0,0,3.789,4.42.25.25,0,0,1,.211.247V19.5a1.5,1.5,0,0,0,1.286,1.484.25.25,0,0,1,.214.248V23a1,1,0,1,0,2,0V21.233a.251.251,0,0,1,.214-.248A1.5,1.5,0,0,0,14.5,19.5V18.168a.25.25,0,0,1,.211-.247A4.488,4.488,0,0,0,18.5,13.5V11A.5.5,0,0,0,18,10.5Z']],
  SocketBox: ['socket-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3.5A2.5,2.5,0,0,0,21.5,1H7.5A2.5,2.5,0,0,0,5,3.5V18.313a.188.188,0,0,1-.188.188,1,1,0,0,1-1-1v-8A2.846,2.846,0,0,0,1,6.5a1,1,0,1,0,0,2c.6,0,.812.539.812,1v8a3,3,0,0,0,3,3h.036A.156.156,0,0,1,5,20.648,2.5,2.5,0,0,0,7.5,23h14A2.5,2.5,0,0,0,24,20.5ZM18.5,14a3,3,0,1,1-3,3A3,3,0,0,1,18.5,14Zm-3-7a3,3,0,1,1,3,3A3,3,0,0,1,15.5,7Zm-5,3a3,3,0,1,1,3-3A3,3,0,0,1,10.5,10Zm3,7a3,3,0,1,1-3-3A3,3,0,0,1,13.5,17Z', 'M17.5,8a.5.5,0,0,0,.5-.5V6.548a.5.5,0,0,0-1,0V7.5A.5.5,0,0,0,17.5,8Z', 'M19.5,8a.5.5,0,0,0,.5-.5V6.548a.5.5,0,0,0-1,0V7.5A.5.5,0,0,0,19.5,8Z', 'M9.5,6.048a.5.5,0,0,0-.5.5V7.5a.5.5,0,0,0,1,0V6.548A.5.5,0,0,0,9.5,6.048Z', 'M11.5,6.048a.5.5,0,0,0-.5.5V7.5a.5.5,0,1,0,1,0V6.548A.5.5,0,0,0,11.5,6.048Z', 'M17.5,18a.5.5,0,0,0,.5-.5v-.953a.5.5,0,0,0-1,0V17.5A.5.5,0,0,0,17.5,18Z', 'M19.5,18a.5.5,0,0,0,.5-.5v-.953a.5.5,0,0,0-1,0V17.5A.5.5,0,0,0,19.5,18Z', 'M9.5,16.048a.5.5,0,0,0-.5.5V17.5a.5.5,0,0,0,1,0v-.953A.5.5,0,0,0,9.5,16.048Z', 'M11.5,16.048a.5.5,0,0,0-.5.5V17.5a.5.5,0,0,0,1,0v-.953A.5.5,0,0,0,11.5,16.048Z']],
  UsbPort: ['usb-port', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,8.5H.5A.5.5,0,0,0,0,9V22.067A1.47,1.47,0,0,0,1.5,23.5h21A1.47,1.47,0,0,0,24,22.067V9A.5.5,0,0,0,23.5,8.5Zm-3,6.5h-4a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v2A1,1,0,0,1,20.5,15Zm1,3v2a1,1,0,0,1-1,1h-4a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1h4A1,1,0,0,1,21.5,18Zm-9-2a5,5,0,1,1-5-5A5.006,5.006,0,0,1,12.5,16Z', 'M.5,7h23a.5.5,0,0,0,.429-.757L20.914,1.2A1.536,1.536,0,0,0,19.58.5H4.42a1.536,1.536,0,0,0-1.334.7L.071,6.244A.5.5,0,0,0,.5,7Z', 'M6.6,12a.638.638,0,0,0-.554.893l.9,2.218a.591.591,0,0,0,1.11,0l.9-2.218A.639.639,0,0,0,8.4,12Z', 'M8.4,20a.64.64,0,0,0,.555-.894l-.9-2.218a.591.591,0,0,0-1.11,0l-.9,2.218A.639.639,0,0,0,6.6,20Z', 'M10.607,14.55l-2.219.9a.591.591,0,0,0,0,1.11l2.219.895A.638.638,0,0,0,11.5,16.9V15.105A.638.638,0,0,0,10.607,14.55Z', 'M4.393,17.451l2.219-.895a.591.591,0,0,0,0-1.11l-2.219-.9a.638.638,0,0,0-.893.555V16.9A.638.638,0,0,0,4.393,17.451Z', 'M17.000 13.001 A0.500 0.500 0 1 0 18.000 13.001 A0.500 0.500 0 1 0 17.000 13.001 Z', 'M19.000 13.001 A0.500 0.500 0 1 0 20.000 13.001 A0.500 0.500 0 1 0 19.000 13.001 Z', 'M17.000 19.001 A0.500 0.500 0 1 0 18.000 19.001 A0.500 0.500 0 1 0 17.000 19.001 Z', 'M19.000 19.001 A0.500 0.500 0 1 0 20.000 19.001 A0.500 0.500 0 1 0 19.000 19.001 Z']],
  BatteryCharge: ['battery-charge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,9.628a1.5,1.5,0,0,0-1.5-1.5h-.25a.25.25,0,0,1-.25-.25V6.628a1.5,1.5,0,0,0-1.5-1.5H15.75a.25.25,0,0,0-.25.25v.389a.251.251,0,0,0,.111.208A1.987,1.987,0,0,1,16.5,7.628v4.5a3.493,3.493,0,0,1-2.8,3.415.249.249,0,0,0-.2.244v1.091a.25.25,0,0,0,.25.25H20a1.5,1.5,0,0,0,1.5-1.5v-1.25a.25.25,0,0,1,.25-.25H22a1.5,1.5,0,0,0,1.5-1.5Z', 'M9.5,15.787a.248.248,0,0,0-.2-.244,3.493,3.493,0,0,1-2.8-3.415v-4.5a1.987,1.987,0,0,1,.889-1.653A.251.251,0,0,0,7.5,5.767V5.378a.25.25,0,0,0-.25-.25H2a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5H9.25a.25.25,0,0,0,.25-.25Z', 'M8.745,5.878a.25.25,0,0,0,.25.25h1.01a.25.25,0,0,0,.25-.25V3.628a.755.755,0,1,0-1.51,0Z', 'M12.745,5.878a.25.25,0,0,0,.25.25h1.01a.25.25,0,0,0,.25-.25V3.628a.755.755,0,0,0-1.51,0Z', 'M12.5,14.378a.25.25,0,0,1,.25-.25H13a2,2,0,0,0,2-2v-4a.5.5,0,0,0-.5-.5h-6a.5.5,0,0,0-.5.5v4a2,2,0,0,0,2,2h.25a.25.25,0,0,1,.25.25v5.75a1,1,0,0,0,2,0Z']],
  WallSocket: ['wall-socket', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.4,0H1.6A1.6,1.6,0,0,0,0,1.6V22.405A1.6,1.6,0,0,0,1.6,24H22.4a1.6,1.6,0,0,0,1.6-1.6V1.6A1.6,1.6,0,0,0,22.4,0ZM12,20.215A8.215,8.215,0,1,1,20.214,12,8.213,8.213,0,0,1,12,20.215Z', 'M9.262,8.512a.75.75,0,0,0-.75.75v5.477a.75.75,0,0,0,1.5,0V9.262A.75.75,0,0,0,9.262,8.512Z', 'M14.738,8.512a.75.75,0,0,0-.75.75v5.477a.75.75,0,0,0,1.5,0V9.262A.75.75,0,0,0,14.738,8.512Z']],
  WallSocket1: ['wall-socket-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,2H3.5C1.227,2,0,7.153,0,12S1.227,22,3.5,22h17c2.273,0,3.5-5.153,3.5-10S22.773,2,20.5,2ZM17.25,6.5V10a.75.75,0,0,1-1.5,0V6.5a.75.75,0,0,1,1.5,0ZM15,15.5v3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-3A2.778,2.778,0,0,1,12,13,2.778,2.778,0,0,1,15,15.5Zm-6.75-9V10a.75.75,0,0,1-1.5,0V6.5a.75.75,0,0,1,1.5,0Z']],
  Charger: ['charger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.206,4.536a1,1,0,0,0-1.414,0L18.886,6.442a.25.25,0,0,1-.354,0L16.057,3.967a.252.252,0,0,1,0-.354l1.906-1.9A1,1,0,1,0,16.549.294L14.643,2.2a.249.249,0,0,1-.353,0l-.463-.462a1.5,1.5,0,0,0-2.121,0L8.525,4.919A5.726,5.726,0,0,0,6.878,9.287a6.592,6.592,0,0,0,.711,2.688.251.251,0,0,1-.046.289L5.7,14.112a.5.5,0,0,0,0,.707l.221.222a.25.25,0,0,1,0,.355L2.379,18.843l0,0a3,3,0,0,0,0,4.241,3.074,3.074,0,0,0,4.242,0L9.8,19.905a.5.5,0,1,1,.708.707L8.827,22.294a1,1,0,0,0,1.414,1.414l1.684-1.683a2.5,2.5,0,0,0-3.537-3.534L5.206,21.673a1.025,1.025,0,0,1-1.414,0,1,1,0,0,1-.01-1.4l0,0,3.549-3.46a.251.251,0,0,1,.351,0l.132.132a.5.5,0,0,0,.707,0L10.369,15.1a.249.249,0,0,1,.289-.046,6.581,6.581,0,0,0,2.964.718,5.739,5.739,0,0,0,4.094-1.656L20.9,10.929a1.5,1.5,0,0,0,0-2.121l-.6-.6a.25.25,0,0,1,0-.354L22.206,5.95A1,1,0,0,0,22.206,4.536ZM13.827,8.808a2,2,0,0,1,0,2.828h0a2,2,0,1,1,0-2.828Z']]
};
exports["default"] = _default;